<template>
  <div class="order-info-wrap">
    <div class="order-info">
      <div class="order-info-title">
        <h4>購物車 > 運送與收件資訊 > 選擇付款方式</h4>
      </div>
      <div>
        <h4>聯絡通知</h4>
        <p>{{receiverInfo.notification}}</p>
      </div>
      <div>
        <h4>排版通知</h4>
        <p>{{is_check===0?'不需要':'需要'}}</p>
      </div>
      <div>
        <h4>寄送資訊</h4>
        <p>
          寄送地區：
          <span>{{receiverInfo.country}}</span>
        </p>
        <p>
          寄送地址：
          <span>{{receiverInfo.postalCode}}{{$store.getters.getCityByZipcode(receiverInfo.postalCode)}}{{$store.getters.getRegionByZipcode(receiverInfo.postalCode)}}{{receiverInfo.address}}</span>
        </p>
        <p>
          寄送方式：
          <span>{{receiverInfo.sendWay}}</span>
        </p>
      </div>
      <div>
        <h4>收貨人資訊</h4>
        <p>
          收件人：
          <span>{{receiverInfo.lastName}}{{receiverInfo.firstName}}</span>
        </p>
        <p>
          手機：
          <span>{{receiverInfo.phone}}</span>
        </p>
        <p>
          電子信箱：
          <span>{{receiverInfo.email}}</span>
        </p>
      </div>
      <div>
        <h4>發票資訊</h4>
        <p>
          發票種類：
          <span>{{receiverInfo.invoiceType}}</span>
        </p>
        <p>
          抬頭：
          <span>{{receiverInfo.invoiceHead}}</span>
        </p>
        <p>
          統一編號：
          <span>{{receiverInfo.invoiceNum}}</span>
        </p>
      </div>
      <div class="payment-method">
        <h4>付款方式</h4>
        <div id="myRadio">
          <input type="radio" id="ATMPay" name="selector" checked>
          <label for="ATMPay">ATM轉帳</label>
          <div class="check"></div>
        </div>
        <p class="note">所有訂單皆爲百分之百客製，付之製作並送達客戶手中之商品無法退貨。</p>
      </div>
      <div class="bottom-links-wrap">
        <div class="checkoutFormContainer" @click.once="finishOrder">完成結帳</div>
        <router-link class="change-delivery" to="/gold/cart/cart_info">
          <div>變更運送與收件資訊</div>
        </router-link>
      </div>
    </div>
    <CartOrdershow id="ordershow"></CartOrdershow>
  </div>
  <!-- <div class="load" v-else>
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
  </div> -->
</template>

<script>
import CartOrdershow from "@/components/cart/cart_ordershow.vue";
import Cookies from "js-cookie";
import axios from "axios";

export default {
  name: "CartConfirm",
  components: {
    CartOrdershow
  },
  updated() {
    let buttonContainer = document.querySelector("#__paymentButton");
    buttonContainer.style.color = "white";
    buttonContainer.style.width = "200px";
    buttonContainer.style.height = "55px";
    buttonContainer.style.border = "0";
    buttonContainer.style.fontSize = "17px";
    buttonContainer.style.backgroundColor = "transparent";
    buttonContainer.value = "完成結帳";
  },
  data() {
    return {
      // checkoutForm: "",
      is_check: "1",
      receiverInfo: ""
    };
  },
  created() {
    this.receiverInfo = Cookies.getJSON("receiptInfo");
    this.is_check = Cookies.getJSON("isCheck");
    this.timeToLeave();
  },
  methods: {
    timeToLeave() {
      setTimeout(
        function() {
          this.$router.push("/gold/homepage");
        }.bind(this),
        3600000
      );
    },
    finishOrder() {
      let orderData = this.sameCompanyDataTransform();
      orderData.is_check = this.is_check;
      orderData.full_name = orderData.lastName + orderData.firstName;
      if (this.isSpecialMember) {
        let specialMemberData = this.$store.getters.getSpecialMemberData;
        orderData.invoiceHead = specialMemberData.company_company_name;
        orderData.invoiceNum = specialMemberData.principal_line_id;
      }
      orderData.address =
        this.$store.getters.getCityByZipcode(orderData.postalCode) +
        this.$store.getters.getRegionByZipcode(orderData.postalCode) +
        orderData.address;
      axios({
        url: this.$store.getters.getGlobalUrl + "orders",
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        data: orderData
      })
        .then(response => {
          this.$store.dispatch("setSameCompanyOrderId", response.data.data.id);
          this.$router.push(`/gold/cart/cart_finish/${response.data.data.id}`);
        })
        .catch(e => {
          alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
        });
    },
    sameCompanyDataTransform() {
      let product = JSON.parse(localStorage.getItem("cartorder"));
      product.forEach(item => {
        delete item.price;
        delete item.total;
        item.size.type = "peer";
        //處理成後端要的格式
        for (let sizeValue in item.size) {
          item[sizeValue] = item.size[sizeValue];
        }
        delete item.size;
        for (let textValue in item.text) {
          item[textValue] = item.text[textValue];
        }
        delete item.text;
      });
      let note = JSON.parse(localStorage.getItem("cartorderNote"));
      if (note === null) {
        note = "";
      }
      let user = this.$store.getters.getToken;
      let orderData = {
        product: product,
        note: note,
        user: user
      };
      for (let receiverInfoValue in this.receiverInfo) {
        orderData[receiverInfoValue] = this.receiverInfo[receiverInfoValue];
      }
      return orderData;
    }
  },
  computed: {
    isSpecialMember() {
      if (this.$store.getters.getToken === "") {
        return false;
      } else if (this.$store.getters.getSpecialMemberState === null) {
        return false;
      } else if (this.$store.getters.getSpecialMemberState === 0) {
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.order-info-wrap {
  display: flex;
  flex-wrap: nowrap;
  padding-left: 105px;
  justify-content: space-between;
  @include table {
    flex-wrap: wrap;
    padding: 0;
    flex-direction: column-reverse;
  }
}

.note {
  color: $secondaryColor2;
}

#ordershow {
  box-sizing: content-box;
  max-width: 600px;
  width: 38%;
  @include table {
    width: 100%;
    max-width: 768px;
    box-sizing: border-box;
  }
}

.order-info {
  padding-bottom: 75px;
  font-size: 17px;
  text-align: left;
  color: $secondaryDeepColor1;
  @include table {
    margin: 16px;
  }
  .order-info-title h4 {
    margin-top: 30px;
    @include phone {
      font-size: 16px;
    }
  }
  h4 {
    margin-top: 32px;
    margin-bottom: 16px;
  }
  p {
    margin: 0px;
    font-size: 17px;
  }

  .payment-method {
    padding-bottom: 16px;
    p {
      width: 60%;
    }
  }
  .bottom-links-wrap {
    display: flex;
    flex-wrap: wrap;
    @include table {
      text-align: center;
    }
    .change-delivery {
      color: $primaryDeepColor;
      font-weight: 800;
      padding: 16px;

      @media screen and (max-width: 822px) {
        display: block;
      }
      > div {
        display: inline-block;
        @include betweenTableTablePro {
          display: block;
        }
      }
    }
    button {
      background: transparent;
      border: 1px solid $primaryDeepColor;
      border-radius: 25px;
      font-size: 17px;
      color: $primaryDeepColor;
      padding: 10px 20px;
      text-align: center;
      width: 200px;
      height: 55px;
      @include table {
        width: 100%;
        max-width: 343px;
      }
      &:hover {
        background-color: $primaryDeepColor;
        color: #fff;
      }
    }
  }
}
/*******************************
radio style
*******************************/
#myRadio {
  position: relative;
}
#myRadio label {
  font-weight: normal;
  display: block;
  position: relative;
  padding: 8px 41px;
  z-index: 3;
  cursor: pointer;
}
#myRadio:hover label {
  color: #bf9f5f;
}
#myRadio .check {
  position: absolute;
  border: 2px solid #a8894c;
  border-radius: 50%;
  height: 25px;
  width: 25px;
  top: 8px;
  left: 0;
  z-index: 2;
  box-sizing: border-box;
}
#myRadio:hover .check {
  border: 2px solid #bf9f5f;
}
#myRadio .check::before {
  display: block;
  position: absolute;
  content: "";
  border-radius: 50%;
  height: 15px;
  width: 15px;
  top: 3px;
  left: 3px;
  margin: auto;
}
#myRadio input[type="radio"] {
  position: absolute;
  visibility: hidden;
}
input[type="radio"]:checked ~ .check::before {
  background: #a8894c;
}
input[type="radio"]:checked ~ label {
  color: #a8894c;
}
.checkoutFormContainer {
  padding: 0;
  background-color: $primaryLightColor;
  color: #fff;
  border: 0;
  font-size: 17px;
  width: 200px;
  border-radius: 50px;
  cursor: pointer;
  display: inline-block;
  line-height: 55px;
  text-align: center;
  &:hover {
    background-color: $primaryDeepColor;
  }
  @include table {
    width: 100%;
    max-width: 343px;
  }
}
//loading
.load {
  padding-top: 160px;
  text-align: center;
}
.load .line:nth-last-child(1) {
  animation: loadingC 0.6s 0.1s linear infinite;
}
.load .line:nth-last-child(2) {
  animation: loadingC 0.6s 0.2s linear infinite;
}
.load .line:nth-last-child(3) {
  animation: loadingC 0.6s 0.3s linear infinite;
}
.line {
  display: inline-block;
  width: 15px;
  height: 15px;
  margin: 3px;
  border-radius: 15px;
  background-color: #a8894c;
}
@keyframes loadingC {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(0, 15px);
  }
  100% {
    transform: translate(0, 0);
  }
}
</style>
